import React from 'react';
import PropTypes from 'prop-types';
import appConfig from '@nerdwallet/app-config';

const PasswordLock = ({ password, children }) => {
  if (password === appConfig.TOTAL_REWARDS_PW) {
    return <div>{children.slice(1)}</div>;
  }

  // return first child if pw incorrect
  return <div>{children[0]}</div>;
};

PasswordLock.propTypes = {
  password: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
};

PasswordLock.displayName = 'PasswordLock';

export default PasswordLock;
